const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// 쪽지 보내기
export async function sendMessage({ cardId, text, senderName, senderCardId, idToken }) {
  const res = await fetch(`${API_BASE}/api/message/${cardId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ text, senderName, senderCardId }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || '메시지 전송 실패');
  return data;
}

// 받은 쪽지 목록
export async function getMyMessages(idToken) {
  try {
    const res = await fetch(`${API_BASE}/api/my/messages`, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
    if (!res.ok) return [];
    const data = await res.json();
    return data.messages || [];
  } catch {
    return [];
  }
}

// 특정 카드에서 온 메시지 읽음 처리
export async function markMessagesRead(cardId, idToken) {
  try {
    await fetch(`${API_BASE}/api/my/messages/read/${cardId}`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${idToken}` },
    });
  } catch {
    // 읽음 처리 실패는 무시
  }
}

// 만난 사람들 (connections + 카드 정보)
export async function getMyNetwork(idToken) {
  try {
    const res = await fetch(`${API_BASE}/api/my/network`, {
      headers: { Authorization: `Bearer ${idToken}` },
    });
    if (!res.ok) return [];
    const data = await res.json();
    return data.connections || [];
  } catch {
    return [];
  }
}
